import { mode } from '@chakra-ui/theme-tools';
export const buttonStyles = {
	components: {
		Button: {
			baseStyle: {
				borderRadius: '16px',
				boxShadow: 'unset',
				transition: '.25s all ease',
				boxSizing: 'border-box',
				_focus: {
					boxShadow: 'none',
				},
				_active: {
					boxShadow: 'none',
				},
				_hover: {
					cursor: 'pointer',
				},
				width: 'fit-content',
				fontSize: { base: 'sm', md: 'md' },
			},
			variants: {
				outline: (props) => ({
					borderColor: mode('brand.500', 'brand.400')(props),
					border: '1px',
					borderRadius: '16px',
					_hover: {
						bg: mode('brand.500', 'brand.400')(props),
						color: mode('gray.100', 'gray.100')(props),
						cursor: 'pointer',
						transform: 'scale(1.02)',
					},
				}),
				brand: (props) => ({
					bg: mode('brand.500', 'gray.100')(props),
					borderColor: mode('brand.500', 'brand.400')(props),
					color: mode('gray.100', 'gray.900')(props),
					_focus: {
						bg: mode('brand.500', 'brand.400')(props),
					},
					_active: {
						bg: mode('brand.500', 'brand.400')(props),
					},
					_hover: {
						bg: mode('gray.900', 'brand.400')(props),
						cursor: 'pointer',
						transform: 'scale(1.02)',
					},
					whiteSpace: 'pre-wrap',
					minHeight: 'fit-content',
					paddingTop: '10px',
					paddingBottom: '10px',
				}),
				darkBrand: (props) => ({
					bg: mode('brand.900', 'gray.100')(props),
					color: mode('gray.100', 'gray.900')(props),
					_focus: {
						bg: mode('brand.900', 'brand.400')(props),
					},
					_active: {
						bg: mode('brand.900', 'brand.400')(props),
					},
					_hover: {
						bg: mode('brand.800', 'brand.400')(props),
						cursor: 'pointer',
						transform: 'scale(1.02)',
					},
				}),
				lightBrand: (props) => ({
					bg: mode('#F2EFFF', 'gray.100Alpha.100')(props),
					color: mode('brand.500', 'gray.100')(props),
					_focus: {
						bg: mode('#F2EFFF', 'gray.100Alpha.100')(props),
					},
					_active: {
						bg: mode('secondaryGray.300', 'gray.100Alpha.100')(props),
					},
					_hover: {
						bg: mode('secondaryGray.400', 'gray.100Alpha.200')(props),
						cursor: 'pointer',
						transform: 'scale(1.02)',
					},
				}),
				light: (props) => ({
					bg: mode('secondaryGray.300', 'secondaryGray.300')(props),
					color: mode('gray.900', 'gray.900')(props),
					_focus: {
						bg: mode('secondaryGray.300', 'gray.100Alpha.100')(props),
					},
					_active: {
						bg: mode('secondaryGray.300', 'gray.100Alpha.100')(props),
					},
					_hover: {
						bg: mode('secondaryGray.400', 'gray.100Alpha.200')(props),
						cursor: 'pointer',
						transform: 'scale(1.02)',
					},
				}),
				action: (props) => ({
					fontWeight: '500',
					borderRadius: '50px',
					bg: mode('secondaryGray.300', 'brand.400')(props),
					color: mode('brand.500', 'gray.100')(props),
					_focus: {
						bg: mode('secondaryGray.300', 'brand.400')(props),
					},
					_active: { bg: mode('secondaryGray.300', 'brand.400')(props) },
					_hover: {
						bg: mode('secondaryGray.200', 'brand.400')(props),
						cursor: 'pointer',
						transform: 'scale(1.02)',
					},
				}),
				setup: (props) => ({
					fontWeight: '500',
					borderRadius: '50px',
					bg: mode('transparent', 'brand.400')(props),
					border: mode('1px solid', '0px solid')(props),
					borderColor: mode('secondaryGray.400', 'transparent')(props),
					color: mode('gray.900', 'gray.100')(props),
					_focus: {
						bg: mode('transparent', 'brand.400')(props),
					},
					_active: { bg: mode('transparent', 'brand.400')(props) },
					_hover: {
						bg: mode('secondaryGray.100', 'brand.400')(props),
						cursor: 'pointer',
						transform: 'scale(1.02)',
					},
				}),
			},
		},
	},
};
